module.exports = __webpack_public_path__ + "img/Reinhard.2baa9063.png";